<template>
  <div class="tab-container-task-library">
    <div class="task-library-back">
      <a href="javascript:void(0)" @click="onBack"><span class="icon-caret-left"></span> Back</a>
    </div>
    <hr />
    <div class="task-library-header">
      <h3>TASK LIBRARY</h3>
    </div>
    <div class="task-library-body">
      <search-input placeholder="SEARCH TOPICS" v-model="searchValue" @search="getTasks" />
      <div class="filter-container">
        <select-dropdown
          v-model="languageValue"
          @input="handleFilterValue"
          :options="languagesList"
          class-select="custom-dropdown--md custom-dropdown--secondary"
        />
        <select-dropdown
          v-model="levelValue"
          @input="handleFilterValue"
          :options="levelList"
          class-select="custom-dropdown--md custom-dropdown--secondary"
        />
        <select-dropdown
          v-model="countryValue"
          @input="handleFilterValue"
          :options="countryList"
          class-select="custom-dropdown--md custom-dropdown--secondary"
        />
      </div>
      <hr />
      <section class="cards">
        <div class="cards-grid" v-show="tasks.length">
          <library-task-card
            v-for="task in tasks"
            :key="task.id"
            @task-selected="goTaskDetail"
            :task="task"
          />
        </div>
        <div class="cards-message" v-show="!tasks.length && !isLoading">
          No tasks were found matching the filter selections. Please adjust the filters to see
          additional options.
        </div>
        <b-overlay no-wrap :show="showLoading" />
      </section>
    </div>
  </div>
</template>

<script>
import LibraryTaskCard from '@/core/components/Card/LibraryTaskCard'
import { SelectDropdown } from '@/core/components/SelectDropdown'
import { SearchInput } from '@/core/components/Inputs'
import { UtilsMixins, ClassroomMixins } from '@/core/Mixins'
import { ClassroomService } from '@/core/Services'

export default {
  name: 'ClassroomDetailTabMyTasksLibraryList',
  mixins: [UtilsMixins, ClassroomMixins],
  components: {
    LibraryTaskCard,
    SelectDropdown,
    SearchInput
  },
  data() {
    return {
      languageValue: '',
      searchValue: '',
      levelValue: '',
      countryValue: '',
      countries: [],
      isLoading: false,
      isMountedLoading: false,
      tasks: [],
      filterOptions: [
        {
          name: 'Language',
          value: 'language'
        },
        {
          name: 'Topic',
          value: 'topic'
        },
        {
          name: 'Level',
          value: 'level'
        },
        {
          name: 'Country',
          value: 'country'
        }
      ]
    }
  },
  methods: {
    onBack() {
      this.$emit('on-change-component', 'ClassroomDetailTabMyTasksList')
    },
    handleFilterValue() {
      this.getTasks()
    },
    handleClear() {
      this.getTasks()
    },
    async getTasks() {
      this.isLoading = true
      try {
        const data = {
          language_id: this.languageValue,
          level_id: this.levelValue,
          country_id: this.countryValue
        }
        const response = await ClassroomService.getTasksLibraryIndependents({
          classroom_id: this.classroom.id,
          data,
          searchString: this.searchValue
        })
        this.tasks = response.data
      } catch (error) {
        console.error(error)
      } finally {
        this.isLoading = false
      }
      return []
    },
    async getTasksCountries() {
      try {
        const response = await ClassroomService.getTasksCountries({
          classroom_id: this.classroom.id
        })
        this.countries = response.data
      } catch (error) {
        console.error(error)
      }
    },
    searchTasks() {},
    goTaskDetail(task) {
      this.$emit('on-change-component', 'ClassroomDetailTabMyTaskLibraryDetail', {
        ...task
      })
    }
  },
  computed: {
    languagesList() {
      return [{ name: 'ALL LANGUAGES', id: '' }, ...this.languages]
    },
    levelList() {
      return [{ name: 'ALL LEVELS', id: '' }, ...this.levels]
    },
    countryList() {
      return [{ name: 'ALL COUNTRIES', id: '' }, ...this.countries]
    },
    showLoading() {
      return this.isMountedLoading || this.isLoading
    }
  },
  async mounted() {
    this.isMountedLoading = true

    const promise1 = new Promise((resolve) => {
      this.getTasks().then(() => resolve(true))
    })
    const promise2 = new Promise((resolve) => {
      this.getTasksCountries().then(() => resolve(true))
    })

    Promise.all([promise1, promise2]).then(() => {
      this.isMountedLoading = false
    })
  },
  watch: {
    searchValue(newValue, oldValue) {
      if (oldValue !== '' && newValue === '') {
        this.handleClear();
      }
    }
  },
}
</script>

<style lang="stylus" scoped>
@import "~@/core/styles/variables.styl"
@import "~@/core/styles/mixins.styl"

.tab-container-task-library
  padding-left 10px
  padding-right 10px
  padding-bottom 99px
  padding-top 13px

.task-library-header
  text-align center
  margin-top 40px
  margin-bottom 40px

  h3
    color color-8
    font font-opensans-bold
    font-size 24px
    margin-bottom 0

  span
    font font-opensans-regular
    font-size 16px
    color color-8

.task-library-body
  padding 0

@media (min-width: 1200px)
  .task-library-body
    padding-left 112px
    padding-right 112px

hr
  background-color color-23
  height 1px
  opacity 1
  margin 0.8em 0

.task-library-back
  a
    font font-opensans-bold
    font-size 17px
    cursor pointer
    text-decoration none
    color color-3
    display flex
    align-items center

    span
      font-size 0.7em
      padding-right 5px

      &:before
        color color-3

.common-search-bar-container
  margin-bottom 10px

.filter-container
  display flex
  justify-content space-between

  .custom-dropdown--md
    width 30%
    margin-right 5px

  .common-search-bar-container, .custom-dropdown--right
    width 70%

  @media (max-width: 700px)
    align-items center
    flex-direction column

    .custom-dropdown--md
      width 100%
      margin-right 0
      margin-bottom 5px

.cards
  position relative
  min-height 200px

  .cards-grid
    display grid
    grid-template-columns repeat(auto-fit, minmax(180px, 1fr))
    gap 16px
    text-align center
    justify-items center
    align-items center
    position relative
    min-height 300px

  .cards-message
    width 100%
    display flex
    justify-content center
</style>
